import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import { get } from 'lodash';

// components
import { Dropdown } from '@tcc/crate';

// utils
import { formatSelectCropListOptions } from './harvestHistoryUtil';

const baseString = 'vra-harvest-crop';

const HarvestCrop = ({
  cropList,
  isAppMode,
  onSelectCrop,
  selectedCropId
}) => {
  const classStringDropdown = classNames({
    [`${baseString}__select`]: true,
    'vra-route-container--app-mode': isAppMode

  });
  return (
    <Dropdown
      className={classStringDropdown}
      options={formatSelectCropListOptions(cropList)}
      placeholder={getMessage('placeholder-text__select-crop')}
      setValue={onSelectCrop}
      testId='select-harvest-crop'
      value={get(cropList, `${selectedCropId}.name`)}
    />
  );
};


HarvestCrop.propTypes ={
  cropList: propTypes.object.isRequired,
  isAppMode: propTypes.bool.isRequired,
  onSelectCrop: propTypes.func.isRequired,
  selectedCropId: propTypes.number
};

export default HarvestCrop;
